import { WidgetType } from 'shared/widgets/utils';

import { createNewSubmitPageSatisfactionSurvey } from './create';
import { manifestLocales } from './manifest.locales';
import SubmitPageSatisfactionSurveyEn from './resources/en/submitPageSatisfactionSurvey.svg';
import SubmitPageSatisfactionSurveyHe from './resources/he/submitPageSatisfactionSurvey.svg';
import { ManifestType } from '@/types/ManifestType';

export const Manifest: ManifestType = {
  name: WidgetType.SubmitPageSatisfactionSurvey,
  previewGroups: [
    {
      id: 'SubmitPageSatisfactionSurvey',
      divider: false,
      previews: [
        {
          name: 'SubmitPageSatisfactionSurvey',
          previewImage: {
            paths: {
              en: SubmitPageSatisfactionSurveyEn,
              he: SubmitPageSatisfactionSurveyHe
            },
            alt: { ...manifestLocales.submitPageSatisfactionSurvey.previewImageAlt },
            size: {
              width: 285,
              height: 44
            }
          },
          initializeProps: createNewSubmitPageSatisfactionSurvey,
          dimensions: {
            width: 1180,
            height: 'auto'
          }
        }
      ]
    }
  ],
  additionalData: {
    constraints: {
      minHeight: 48,
      minWidth: 100
    }
  }
};
